import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ChevronLeftIcon } from '@chakra-ui/icons'
import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'

import Icon from '../../../shared/icon'

import { toggleNavbar } from '../../../../redux/features/navbarSlice'
import { DEFAULT_VALUES } from '../../../../utils/default'
import {
	clearLastZone,
	clearLocalAuth,
} from '../../../../services/app/localStorage'
import { clearAuthData, login } from '../../../../redux/features/authSlice'

const Header = ({ title = '', inner = false, business, type }) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const handleLogout = () => {
		clearLocalAuth()
		dispatch(login(null))
		dispatch(clearAuthData())
		clearLastZone()
		navigate('/login')
	}

	return (
		<header className='bg-primary-color h-[65px] fixed z-[99] top-0 left-0 right-0 shadow-md flex flex-row items-center justify-between px-8'>
			<img
				src='/assets/img/agus-icon-white.png'
				alt=''
				className='hidden md:block w-[20px]'
			/>
			{!inner && (
				<button
					onClick={() => dispatch(toggleNavbar())}
					className='block md:hidden'
				>
					<Icon icon='bars' size='xl' />
				</button>
			)}
			{inner && (
				<button onClick={() => navigate(-1)} className='block md:hidden'>
					<ChevronLeftIcon color='white' boxSize={8} />
				</button>
			)}
			{inner && title && (
				<p className='text-sm md:text-md lg:text-lg text-white font-bold'>
					{title}
				</p>
			)}
			<Menu>
				<MenuButton>
					<div className='flex flex-row items-center gap-3'>
						<p className='hidden md:block text-sm md:text-md lg:text-lg text-white font-bold'>
							{business?.name ?? 'Nombre'}
						</p>
						<img
							src={business?.image || DEFAULT_VALUES['square-image']}
							alt=''
							className='w-[32px] h-[32px] rounded-full'
						/>
					</div>
				</MenuButton>
				<MenuList>
					<MenuItem
						onClick={() =>
							navigate(
								type === 'partner' || type === 'deliveries-provider'
									? '/account'
									: '/information'
							)
						}
					>
						Perfil
					</MenuItem>
					<MenuItem onClick={handleLogout}>Salir</MenuItem>
				</MenuList>
			</Menu>
		</header>
	)
}

export default Header
